<template>
    <TopNavigation v-model="mobileMenuOpen">
        <template #items>
            <NotificationsDropdown />
        </template>
        <template #desktop-items>
            <AdminProfileDropdown :profileImage="profileImage ?? ''" />
        </template>
    </TopNavigation>
</template>

<script setup lang="ts">
    import TopNavigation from "@/components/TopNavigation.vue";
    import NotificationsDropdown from "@/components/client/NotificationsDropdown.vue";
    import AdminProfileDropdown from "@/components/admin/AdminProfileDropdown.vue";

    defineProps<{
        profileImage: string | null
    }>()

    const mobileMenuOpen = defineModel<boolean>('mobileMenuOpen', { required: true });
</script>
